<template>
  <div v-if="validationStatus.$error">
    <p class="help-block" v-for="$error in validationStatus.$errors" :key="$error.$property">
      {{ $error.$message }}
    </p>
  </div>
</template>
<script>
export default {
  name: "FormErrorMessage",
  props: {
    validationStatus: {
      type: Object,
      required: true
    },
  }
};
</script>